import { useQuery } from "react-query";

const MANIFEST_PATH = "/experiments-manifest.json";

const fetchManifest = async (labBaseUrl) => {
  if (!labBaseUrl) {
    return null;
  }
  try {
    const res = await fetch(`${labBaseUrl}${MANIFEST_PATH}`, { credentials: "omit" });
    if (!res.ok) {
      return null;
    }
    return await res.json();
  } catch {
    // The lab service may be unreachable (e.g. not running locally); treat the
    // manifest as unavailable rather than surfacing a query error, since every
    // consumer already fails closed on a falsy manifest.
    return null;
  }
};

/**
 * Fetches the experiments manifest published by the lab. Manifest is cached
 * across the session; refetches at most once every 5 minutes.
 */
export const useExperimentsManifest = () => {
  const labBaseUrl = process.env.LAB_BASE_URL;
  const query = useQuery(["experimentsManifest", labBaseUrl], () => fetchManifest(labBaseUrl), {
    enabled: !!labBaseUrl,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
  return {
    ...query,
    manifest: query.data || null,
  };
};

export { MANIFEST_PATH };
